import { IChartContainer } from "../models/base/chart-container.interface";
import { IComponent } from "./component.interface";

export class PnPSwitchComponent implements IComponent {
    public id = '';

    private element: HTMLElement;
    private base: IChartContainer;

    public switched = false;

    constructor(element: HTMLElement, base: IChartContainer) {
        this.element = element;
        this.base = base;
        this.onElementClick();
    }

    private onElementClick() {
        this.element.addEventListener('click', () => {
            this.requestTimeFrame();
            this.togglePnPMode();
        });
    }

    public togglePnPMode() {
        console.log(' togglePnPMode ')
        this.switched = !this.switched;
        const base = this.base as any;
        base.pnpContainer?.element?.findFirst('.controls').ifExistThen((el: HTMLElement) => {
            if (this.switched) {
                el.addClass('hidden');
            } else {
                el.removeClass('hidden');
            }
        });
    }

    public requestTimeFrame() {
        const base = this.base as any;
        const pnpContainerChartService = base.pnpContainer?.chartService;
        const pnpChartTimeFrame = base.pnpContainer?.tiChartSeries?.currentTimeframe;
        const mainChartTimeFrame = base.tiChartSeries.currentTimeframe;
        this.base.chartService.requestNewTimeframe(pnpChartTimeFrame);
        if (pnpContainerChartService) {
            pnpContainerChartService.requestNewTimeframe(mainChartTimeFrame);
        }
    }
}